import React, { Component } from 'react'
import emailjs from '@emailjs/browser';

// EmailJS'i initialize et
emailjs.init('Az-zxQte9desY0vlu');

// CSS stilini ekle
const spinnerStyle = {
    width: '20px',
    height: '20px',
    border: '3px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '50%',
    borderTopColor: '#fff',
    animation: 'spin 1s ease-in-out infinite',
    marginRight: '10px',
    display: 'inline-block'
};

// Keyframe animasyonunu ekle
const styleSheet = document.createElement("style");
styleSheet.textContent = `
    @keyframes spin {
        to { transform: rotate(360deg); }
    }
`;
document.head.appendChild(styleSheet);

class ContactForm extends Component {
    state = {
        name: '',
        lastname: '',
        email: '',
        subject: '',
        message: '',
        error: {},
        sending: false,
        sent: false
    }

    changeHandler = (e) => {
        const error = this.state.error;
        error[e.target.name] = ''

        this.setState({
            [e.target.name]: e.target.value,
            error
        })
    }

    submitHandler = (e) => {
        e.preventDefault();
        console.log('Form submit edildi');

        const { name, lastname, email, subject, message } = this.state;
        let error = {};  // Yeni boş error objesi oluştur

        // Validasyon kontrolleri
        if (name === '') {
            error.name = "Lütfen adınızı girin";
        }
        if (lastname === '') {
            error.lastname = "Lütfen soyadınızı girin";
        }
        if (email === '') {
            error.email = "Lütfen e-posta adresinizi girin";
        }
        if (subject === '') {
            error.subject = "Lütfen konu girin";
        }
        if (message === '') {
            error.message = "Lütfen mesajınızı girin";
        }

        console.log('Validasyon hataları:', error);

        if (Object.keys(error).length > 0) {
            this.setState({ error });
            console.log('Validasyon hatası var, form gönderilmedi');
            return;
        }

        // Email gönderme işlemi
        this.setState({ sending: true });

        const templateParams = {
            from_name: `${name} ${lastname}`,
            from_email: email,
            subject: subject,
            message: message
        };

        console.log('Email gönderme başladı', templateParams);

        emailjs.send(
            'sedas_mail',
            'template_8qj91t4',
            templateParams,
            'Az-zxQte9desY0vlu'
        )
        .then((response) => {
            console.log('Email başarıyla gönderildi', response);
            this.setState({
                name: '',
                lastname: '',
                email: '',
                subject: '',
                message: '',
                error: {},
                sending: false,
                sent: true
            });
            alert('Mesajınız başarıyla gönderildi!');
        })
        .catch((err) => {
            console.error('Email gönderme hatası:', err);
            this.setState({ sending: false });
            alert('Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
        });
    }

    render() {
        const { name, lastname, email, subject, message, error, sending } = this.state;

        return(
            <form onSubmit={this.submitHandler} className="form">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-field">
                            <input 
                                onChange={this.changeHandler} 
                                value={name} 
                                type="text" 
                                name="name" 
                                placeholder="Adınız"
                            />
                            <p>{error.name ? error.name : ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-field">
                            <input 
                                onChange={this.changeHandler} 
                                value={lastname} 
                                type="text" 
                                name="lastname" 
                                placeholder="Soyadınız"
                            />
                            <p>{error.lastname ? error.lastname : ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-field">
                            <input 
                                onChange={this.changeHandler} 
                                value={email} 
                                type="email" 
                                name="email" 
                                placeholder="E-posta Adresiniz"
                            />
                            <p>{error.email ? error.email : ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-field">
                            <input 
                                onChange={this.changeHandler} 
                                value={subject} 
                                type="text" 
                                name="subject" 
                                placeholder="Konu"
                            />
                            <p>{error.subject ? error.subject : ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-field">
                            <textarea 
                                onChange={this.changeHandler}
                                value={message}
                                name="message" 
                                placeholder="Mesajınız"
                            ></textarea>
                            <p>{error.message ? error.message : ''}</p>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-submit" style={{ display: 'flex', justifyContent: 'center' }}>
                            <button 
                                type="submit" 
                                className="template-btn"
                                disabled={sending}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            >
                                {sending ? (
                                    <>
                                        <div style={spinnerStyle}></div>
                                        <span>Gönderiliyor</span>
                                    </>
                                ) : 'Mesaj Gönder'}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default ContactForm;